import { React, useRef, useState } from "react";
import AppButton from "../../../../base/AppButton.component";
import printJS from "print-js";
import { Box, CircularProgress, Paper } from "@mui/material";
import VerificationDocument from "../../../../../utils/VerificationDocument";
import ReactToPrint, { useReactToPrint } from "react-to-print";

const DocumentDialog = ({
  url,
  showPrintButton = true,
  customer,
  insuranceList,
}) => {
  const [loading, setLoading] = useState(true);
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  // url = null;
  console.log("customerdetailsCartDOCUMETN", url);
  return (
    <>
      {url && loading ? (
        <Box
          style={{
            width: "100%",
            textAlign: "center",
            marginTop: "50px",
          }}
        >
          <CircularProgress />
        </Box>
      ) : null}
      {url ? (
        <iframe
          src={`${url}#toolbar=0&#zoom=FitH&zoom=105`}
          style={{ width: "100%", height: "66vh" }}
          onLoad={() => setLoading(false)}
          title="title"
          frameBorder="0"
          onError={() => {
            console.log("error");
          }}
          // ref={printRef}
          id="document"
        />
      ) : (
        <VerificationDocument
          ref={printRef}
          customer={customer}
          insuranceList={insuranceList}
        />
      )}
      {showPrintButton && (
        <AppButton
          buttonText="Print Document"
          clickHandler={() => (url ? printJS(url) : handlePrint())}
          size="medium"
          variant="contained"
          sx={{ flex: 1, mx: "auto", width: "50%", my: 1 }}
        />
      )}
    </>
  );
};

export default DocumentDialog;
